(function ($) {
	window.sr = ScrollReveal({
		reset: true,
		mobile: true,
	});

	//left
	var effect_left = {
		origin: "left",
		distance: "50px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 1200,
	};
	sr.reveal(".js-sldl", effect_left, 100);

	//left2
	var effect_left2 = {
		origin: "left",
		distance: "50px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 1800,
	};
	sr.reveal(".js-sldl2", effect_left2, 100);

	//left3
	var effect_left3 = {
		origin: "left",
		distance: "50px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 2400,
	};
	sr.reveal(".js-sldl3", effect_left3, 100);

	//left4
	var effect_left4 = {
		origin: "left",
		distance: "50px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 3000,
	};
	sr.reveal(".js-sldl4", effect_left4, 100);

	//left5(once)
	var effect_left5 = {
		origin: "left",
		distance: "50px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 1200,
		reset: false,
	};
	sr.reveal(".js-sldl5", effect_left5, 100);

	//left6(once)
	var effect_left6 = {
		origin: "left",
		distance: "50px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 1800,
		reset: false,
	};
	sr.reveal(".js-sldl6", effect_left6, 100);

	//right
	var effect_right = {
		origin: "right",
		distance: "50px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 1200,
	};
	sr.reveal(".js-sldr", effect_right, 100);

	//right2
	var effect_right2 = {
		origin: "right",
		distance: "50px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 1800,
	};
	sr.reveal(".js-sldr2", effect_right2, 100);

	//right3
	var effect_right3 = {
		origin: "right",
		distance: "50px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 2400,
	};
	sr.reveal(".js-sldr3", effect_right3, 100);

	//right4
	var effect_right4 = {
		origin: "right",
		distance: "50px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 3000,
	};
	sr.reveal(".js-sldr4", effect_right4, 100);

	//right5(once)
	var effect_right5 = {
		origin: "right",
		distance: "50px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 3000,
		reset: false,
	};
	sr.reveal(".js-sldr5", effect_right5, 100);

	//top
	var effect_top = {
		origin: "top",
		distance: "50px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 1200,
	};
	sr.reveal(".js-sldt", effect_top, 100);

	//top2
	var effect_top2 = {
		origin: "top",
		distance: "50px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 1800,
	};
	sr.reveal(".js-sldt2", effect_top2, 100);

	//top3
	var effect_top3 = {
		origin: "top",
		distance: "50px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 2400,
	};
	sr.reveal(".js-sldt3", effect_top3, 100);

	//top4
	var effect_top4 = {
		origin: "top",
		distance: "50px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 3000,
	};
	sr.reveal(".js-sldt4", effect_top4, 100);

	//top(once)
	var effect_top5 = {
		origin: "top",
		distance: "50px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 1200,
		reset: false,
	};
	sr.reveal(".js-sldt5", effect_top5, 100);

	//bottom
	var effect_bottom = {
		origin: "bottom",
		distance: "50px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 1200,
	};
	sr.reveal(".js-sldb", effect_bottom, 100);

	//bottom2
	var effect_bottom2 = {
		origin: "bottom",
		distance: "150px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 1800,
	};
	sr.reveal(".js-sldb2", effect_bottom2, 100);

	//bottom3
	var effect_bottom3 = {
		origin: "bottom",
		distance: "250px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 2400,
	};
	sr.reveal(".js-sldb3", effect_bottom3, 100);

	//bottom4
	var effect_bottom4 = {
		origin: "bottom",
		distance: "250px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 3000,
	};
	sr.reveal(".js-sldb4", effect_bottom4, 100);

	//bottom5(once)
	var effect_bottom5 = {
		origin: "bottom",
		distance: "250px",
		scale: 1,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 3000,
		reset: false,
	};
	sr.reveal(".js-sldb5", effect_bottom5, 100);

	//zoomout
	var effect_zoomOut = {
		distance: "0px",
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 1200,
	};
	sr.reveal(".js-zmout", effect_zoomOut, 100);

	//zoomin
	var effect_zoomIn = {
		distance: "0px",
		scale: 0.5,
		rotate: {
			x: 0,
			y: 0,
			z: 0,
		},
		duration: 1200,
		reset: false,
	};
	sr.reveal(".js-zmin", effect_zoomIn, 100);

	//delay
	var effect_delay = {
		delay: 500,
	};
	sr.reveal(".js-delay", effect_delay);

	//fadein
	var effect_fade = {
		opacity: 0,
		duration: 1000,
	};
	sr.reveal(".js-fadeIn", effect_fade);
})(jQuery);
